import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, slicedToArray as _slicedToArray, createForOfIteratorHelper as _createForOfIteratorHelper } from './_virtual/_rollupPluginBabelHelpers.mjs';
import { createQueryString } from '@toss/utils';
import { SPEED_DEFAULT } from './AnimationData.mjs';
import { AnimationPlayer } from './AnimationPlayer.mjs';
import { importLottie } from './importLottie.mjs';

function AnimationChain(animationInfos, options) {
  var currentPlayer;
  var players;
  return {
    setSpeed: function setSpeed(speed) {
      if (currentPlayer) {
        currentPlayer.setSpeed(speed);
      }
    },
    prepare: function prepare() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var lottiePromise, jsonsPromise, _yield$Promise$all, _yield$Promise$all2, lottie, jsons, sourceUrl;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(players === undefined)) {
                  _context2.next = 11;
                  break;
                }

                lottiePromise = importLottie();
                jsonsPromise = Promise.all(animationInfos.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(animation) {
                    var response;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!('url' in animation)) {
                              _context.next = 7;
                              break;
                            }

                            _context.next = 3;
                            return fetch("".concat(animation.url).concat(createQueryString({
                              version: animation.version
                            })));

                          case 3:
                            response = _context.sent;
                            return _context.abrupt("return", response.json());

                          case 7:
                            return _context.abrupt("return", JSON.parse(animation.json));

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));
                _context2.next = 5;
                return Promise.all([lottiePromise, jsonsPromise]);

              case 5:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                lottie = _yield$Promise$all2[0];
                jsons = _yield$Promise$all2[1];
                sourceUrl = animationInfos.length === 1 && 'url' in animationInfos[0] ? animationInfos[0].url : undefined;
                players = jsons.map(function (json, index) {
                  var isLast = index === animationInfos.length - 1;
                  return AnimationPlayer(json, {
                    lottie: lottie,
                    container: options.container,
                    assets: animationInfos[0].assets,
                    loop: isLast && options.loop,
                    interval: options.interval,
                    lottieUrl: sourceUrl
                  });
                });

              case 11:
                return _context2.abrupt("return", players);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    showFirstFrame: function showFirstFrame() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var preparedPlayers, firstPlayer;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.prepare();

              case 2:
                preparedPlayers = _context3.sent;
                firstPlayer = preparedPlayers[0];

                if (firstPlayer) {
                  firstPlayer.load();
                  firstPlayer.showFirstFrame();
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    addEventListener: function addEventListener(eventName, callback) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var preparedPlayers;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this2.prepare();

              case 2:
                preparedPlayers = _context4.sent;
                preparedPlayers.forEach(function (player) {
                  player.addEventListener(eventName, callback);
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    removeEventListener: function removeEventListener(eventName, callback) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var preparedPlayers;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this3.prepare();

              case 2:
                preparedPlayers = _context5.sent;
                preparedPlayers.forEach(function (player) {
                  player.removeEventListener(eventName, callback);
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    start: function start() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _ref2, _ref2$stopPreviousPla, stopPreviousPlay, _ref2$speed, speed, preparedPlayers, _iterator, _step, player;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref2 = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref2$stopPreviousPla = _ref2.stopPreviousPlay, stopPreviousPlay = _ref2$stopPreviousPla === void 0 ? false : _ref2$stopPreviousPla, _ref2$speed = _ref2.speed, speed = _ref2$speed === void 0 ? SPEED_DEFAULT : _ref2$speed;

                if (!(currentPlayer !== undefined)) {
                  _context6.next = 8;
                  break;
                }

                if (!stopPreviousPlay) {
                  _context6.next = 7;
                  break;
                }

                currentPlayer.destroy();
                currentPlayer = undefined;
                _context6.next = 8;
                break;

              case 7:
                return _context6.abrupt("return");

              case 8:
                _context6.next = 10;
                return _this4.prepare();

              case 10:
                preparedPlayers = _context6.sent;
                _iterator = _createForOfIteratorHelper(preparedPlayers);
                _context6.prev = 12;

                _iterator.s();

              case 14:
                if ((_step = _iterator.n()).done) {
                  _context6.next = 24;
                  break;
                }

                player = _step.value;

                if (currentPlayer !== undefined) {
                  currentPlayer.destroy();
                }

                currentPlayer = player;
                player.load();
                player.setSpeed(speed);
                _context6.next = 22;
                return player.play();

              case 22:
                _context6.next = 14;
                break;

              case 24:
                _context6.next = 29;
                break;

              case 26:
                _context6.prev = 26;
                _context6.t0 = _context6["catch"](12);

                _iterator.e(_context6.t0);

              case 29:
                _context6.prev = 29;

                _iterator.f();

                return _context6.finish(29);

              case 32:
                currentPlayer = undefined;

              case 33:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[12, 26, 29, 32]]);
      }))();
    },
    destroy: function destroy() {
      if (currentPlayer !== undefined) {
        currentPlayer.destroy();
        currentPlayer = undefined;
      }
    },
    play: function play() {
      if (currentPlayer !== undefined) {
        currentPlayer.play();
      }
    },
    pause: function pause() {
      if (currentPlayer !== undefined) {
        currentPlayer.pause();
      }
    }
  };
}

export { AnimationChain };
